import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Lock, ArrowRight, Building2, Truck } from 'lucide-react';
import { BrandHero, CtaBand } from '@/components/brand/BrandKit';

const HERO_IMG = "/brand/fleet-tech-map.jpg";

const portals = [
  { testid: "corporate-portal-card", icon: Building2, title: "Corporate Client Portal", desc: "Sign in to your Eurogulf 360 Mobility corporate account to manage bookings, quotes and your verified company documents. New corporate accounts are approved by our team.", access: "Secure login · UAE PASS, Google or email & password", to: "/login?type=corporate", cta: "Sign in or create a corporate account" },
  { testid: "driver-portal-card", icon: Truck, title: "Driver / Partner Portal", desc: "Access driver schedules, trip assignments, compliance documentation, and operational resources. Available to registered drivers and transport partners within the Eurogulf Mobility Group network.", access: "Secure login required · Contact operations for access" },
];

export default function PortalPage() {
  useEffect(() => { document.title = "Client & Partner Portals | Eurogulf Mobility Group"; }, []);

  return (
    <div data-testid="portal-page">
      <BrandHero testid="portal-hero" chip="Secure Access" title="Client & Partner Portals" lead="Secure access for corporate clients and driver/partner accounts." image={HERO_IMG} imageAlt="Fleet technology map" position="center" />

      <section className="bg-white py-14 sm:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 gap-px overflow-hidden rounded-xl border border-black/[0.06] bg-black/[0.06]">
          {portals.map((p) => (
            <div key={p.testid} data-testid={p.testid} className="bg-white p-6 sm:p-8 hover:bg-[#FFF4ED]/70 transition-colors">
              <div className="flex items-start gap-5">
                <span className="grid h-11 w-11 place-items-center rounded-lg bg-[#FFF4ED] text-[#EE5A01] flex-shrink-0"><p.icon className="w-5 h-5" /></span>
                <div className="flex-1">
                  <h2 className="font-heading font-bold text-xl text-[#121212]">{p.title}</h2>
                  <p className="mt-2 font-body text-sm text-[#666666] leading-relaxed">{p.desc}</p>
                  <p className="mt-4 flex items-center gap-2 font-body text-xs text-[#888]"><Lock className="w-3.5 h-3.5" /> {p.access}</p>
                  <Link to={p.to || "/contact"} data-testid={`${p.testid}-cta`} className="mt-4 inline-flex items-center gap-2 font-heading font-bold text-sm text-[#EE5A01] hover:gap-3 transition-all">{p.cta || 'Request Portal Access'} <ArrowRight className="w-4 h-4" /></Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <CtaBand eyebrow="Need help?" title="Portal access support." desc="Need help with portal access? Contact your account manager or reach out to our support team."
        ctas={[{ label: 'Contact Support', href: '/contact', testid: 'portal-contact-cta' }]} />
    </div>
  );
}
